"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackRecordSchema = void 0;
exports.TrackRecordSchema = {
    "$id": "https://www.redbull.com/schemas/attributes/track-record.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "TrackRecord",
    "description": "Track record",
    "type": "object",
    "additionalProperties": false,
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "attributes:track-record"
            ]
        },
        "records": {
            "type": "array",
            "items": {
                "type": "object",
                "properties": {
                    "discipline": {
                        "$ref": "https://www.redbull.com/schemas/attributes/text.schema.json"
                    },
                    "description": {
                        "$ref": "https://www.redbull.com/schemas/attributes/textual-artefact-container.schema.json"
                    },
                    "dateTime": {
                        "$ref": "https://www.redbull.com/schemas/attributes/date-year.schema.json"
                    },
                    "location": {
                        "$ref": "https://www.redbull.com/schemas/attributes/text.schema.json"
                    },
                    "record": {
                        "$ref": "https://www.redbull.com/schemas/attributes/text.schema.json"
                    }
                },
                "required": [
                    "record"
                ]
            },
            "minItems": 1
        }
    },
    "required": [
        "records",
        "type"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHJhY2stcmVjb3JkLnNjaGVtYS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9tb2R1bGVzL2F0dHJpYnV0ZXMvdHJhY2stcmVjb3JkLnNjaGVtYS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBYSxRQUFBLGlCQUFpQixHQUFHO0lBQy9CLEtBQUssRUFBRSxxRUFBcUU7SUFDNUUsU0FBUyxFQUFFLDhDQUE4QztJQUN6RCxPQUFPLEVBQUUsYUFBYTtJQUN0QixhQUFhLEVBQUUsY0FBYztJQUM3QixNQUFNLEVBQUUsUUFBUTtJQUNoQixzQkFBc0IsRUFBRSxLQUFLO0lBQzdCLFlBQVksRUFBRTtRQUNaLE1BQU0sRUFBRTtZQUNOLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLE1BQU0sRUFBRTtnQkFDTix5QkFBeUI7YUFDMUI7U0FDRjtRQUNELFNBQVMsRUFBRTtZQUNULE1BQU0sRUFBRSxPQUFPO1lBQ2YsT0FBTyxFQUFFO2dCQUNQLE1BQU0sRUFBRSxRQUFRO2dCQUNoQixZQUFZLEVBQUU7b0JBQ1osWUFBWSxFQUFFO3dCQUNaLE1BQU0sRUFBRSw2REFBNkQ7cUJBQ3RFO29CQUNELGFBQWEsRUFBRTt3QkFDYixNQUFNLEVBQUUsbUZBQW1GO3FCQUM1RjtvQkFDRCxVQUFVLEVBQUU7d0JBQ1YsTUFBTSxFQUFFLGtFQUFrRTtxQkFDM0U7b0JBQ0QsVUFBVSxFQUFFO3dCQUNWLE1BQU0sRUFBRSw2REFBNkQ7cUJBQ3RFO29CQUNELFFBQVEsRUFBRTt3QkFDUixNQUFNLEVBQUUsNkRBQTZEO3FCQUN0RTtpQkFDRjtnQkFDRCxVQUFVLEVBQUU7b0JBQ1YsUUFBUTtpQkFDVDthQUNGO1lBQ0QsVUFBVSxFQUFFLENBQUM7U0FDZDtLQUNGO0lBQ0QsVUFBVSxFQUFFO1FBQ1YsU0FBUztRQUNULE1BQU07S0FDUDtDQUNGLENBQUEifQ==